import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIService } from 'src/app/shared/services/api.service';
import { Constants } from './../../shared/constants';
import { AppConfigService } from 'src/app/shared/services/app-config/app-config.service';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private router: Router,
    private http: HttpClient,
    private _apiService: APIService
  ) {
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'token, XSRF-TOKEN, x-xsrf-token, isOngoingCall, emailId, userId, elevatorId, x-ms-request-id, x-ms-request-root-id, incidentId, Origin, X-Requested-With, Content-Type, Accept,Token,(origin == null ? "*" : origin)'
    }),
    withCredentials: true,  //this is required so that Angular returns the Cookies received from the server. The server sends cookies in Set-Cookie header. Without this, Angular will ignore the Set-Cookie header
    observe: 'response' as 'response'

  };


  loginAPI(payload: object): Observable<any> {
    AppConfigService.trackEvent("logServices", { name: "LoginService - loginAPI" }, { url: Constants.SUPERVISOR_DASHBOARD_URLS.getSupervisorTeams, payload: payload });
    return this._apiService.post(payload, Constants.API_URLS.login);
  }

  getCSRFToken() {
    return this._apiService.get(Constants.API_URLS.csrf);
  }

  forgotPassword(payload:any) {
    AppConfigService.trackEvent("logServices", { name: "LoginService - forgotPassword" }, { url: Constants.API_URLS.recoverypassword, payload: payload });
    return this._apiService.post(payload, Constants.API_URLS.recoverypassword);
  }

  changePassword(data: any) {
    return this._apiService.post(data, Constants.API_URLS.changePassword);
  }

  editUserPreferences(data: any) {
    return this._apiService.post(data, Constants.API_URLS.editUserPreferences);
  }

}
